import { useId, useState } from 'react';

export default function AccessibleFaqItem({ question, children }) {
  const [open, setOpen] = useState(true);
  const id = useId();
  return (
    <div className={'faq-item' + (open ? ' open' : '')}>
      <div className="faq-q">
        <h3 className="faq-question-heading">
          <button
            type="button"
            className="faq-trigger"
            aria-expanded={open}
            aria-controls={id}
            onClick={() => setOpen((value) => !value)}
          >
            {question}
          </button>
        </h3>
        <span className="faq-toggle" aria-hidden="true">
          {open ? '−' : '+'}
        </span>
      </div>
      <div className="faq-a" id={id} hidden={!open}>
        <div className="faq-a-inner">{children}</div>
      </div>
    </div>
  );
}
